import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { UserReducer } from "./reducers/userReducer";
import { PostReducer } from "./reducers/postReducer";
import { SettingReducer } from "./reducers/settingReducer";
import { CommentReducer } from "./reducers/commentReducer";
import { TermsReducer } from "./reducers/termReducer";
import { StoryReducer } from "./reducers/storyReducer";

// Import LogRocket and LogRocket Redux middleware
import LogRocket from "logrocket";



const rootReducer = combineReducers({
  Users: UserReducer,
  Posts: PostReducer,
  Terms: TermsReducer,
  Comments: CommentReducer,
  Settings: SettingReducer,
  Stories: StoryReducer
});

// Create the Redux store with middleware
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(LogRocket.reduxMiddleware())
});

export default store;